import { render, staticRenderFns } from "./OrdercountArsip.vue?vue&type=template&id=4c6012a8"
import script from "./OrdercountArsip.vue?vue&type=script&lang=js"
export * from "./OrdercountArsip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports